import React, { useEffect, useState } from 'react';
import { Button, Box, Modal, Typography, TextField, useMediaQuery } from '@mui/material';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { GROUPTYPE_SERVER } from '../../Config';

import SuccessModal from '../common/SuccessModal';
import FailModal from './../common/FailModal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
};

const ManageLicenseTypeModal = (props) => {
  const matches = useMediaQuery('(max-width:1024px)');
  // result message modal
  const [modalMessageTitle, setModalMessageTitle] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openFailModal, setOpenFailModal] = useState(false);

  const resultModalHandleClose = (e) => {
    setModalMessageTitle('');
    setModalMessage('');
    setOpenSuccessModal(false);
    setOpenFailModal(false);
    setValue('groupTypeName', '');
  };
  let wordRegex = /^(?=.*\S)[A-Za-z0-9~!@#$%^&*()_+=,.? ]*[A-Za-z0-9~!@#$%^&*()_+=,.?]$/u;
  const validationSchema = Yup.object().shape({
    groupTypeName: Yup.string()
      .required('Please enter a License Type.')
      .matches(wordRegex, {
        message: `Only English alphabets, numbers, and some special characters can be entered.
      Allowed special characters: ~․! @ # $ % ^ & * ( ) _ - + = , . ?.`,
      }),
  });

  const {
    handleSubmit,
    register,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      groupTypeName: '',
      id: '',
      type: '',
    },
    resolver: yupResolver(validationSchema),
  });

  //add or edit license type
  const onSubmit = async (data, e) => {
    axios.post(`${process.env.REACT_APP_SERVER}${GROUPTYPE_SERVER}`, data).then((res) => {
      if (res.data.err) {
        setModalMessageTitle('Failed to Update');
        setModalMessage(res.data.msg);
        setOpenFailModal(true);
        props.handleClose();
      } else {
        setModalMessageTitle('Updated Successfully');
        setOpenSuccessModal(true);
        props.handleClose();
      }
    });
  };

  useEffect(() => {
    if (props.open) {
      clearErrors('groupTypeName');
      setValue('groupTypeName', props.details.typeName ? props.details.typeName : '');
      setValue('id', props.details.id);
      setValue('type', props.details.type);
    }
  }, [props.open]);

  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" style={{ margin: 16, fontWeight: 600, fontSize: '28px' }}>
            {props.details && props.details.type} a License Type
          </Typography>

          <Typography id="modal-modal-description" sx={{ mt: 2, pb: 2 }} variant="subtitle1">
            {props.details && props.details.messageTitle}
          </Typography>
          <TextField
            size="small"
            inputProps={{
              maxLength: 60,
            }}
            {...register('groupTypeName')}
            error={Boolean(errors.groupTypeName)}
            helperText={errors.groupTypeName?.message}
            style={{ width: matches ? '75%' : '100%' }}
          />
          <div style={{ marginTop: '16px', justifyContent: 'center' }}>
            <Button
              size="small"
              variant="contained"
              color="error"
              sx={{ textTransform: 'none', marginRight: '24px' }}
              onClick={handleSubmit(onSubmit)}
            >
              Save
            </Button>
            <Button
              size="small"
              variant="outlined"
              color="inherit"
              onClick={props.handleClose}
              sx={{ textTransform: 'none' }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>

      <SuccessModal messageTitle={modalMessageTitle} open={openSuccessModal} handleClose={resultModalHandleClose} />
      <FailModal
        messageTitle={modalMessageTitle}
        message={modalMessage}
        open={openFailModal}
        handleClose={resultModalHandleClose}
      />
    </div>
  );
};

export default ManageLicenseTypeModal;
